import React from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import Loader from '../../../components/Loader/Loader';
import NotFound from '../../notFound/NotFound';
import ServicePlansBookForm from '../../../components/ServicePlanContainer/ServicePlansPayment/ServicePlansBookForm';
import ServicePlansInformation from '../../../components/ServicePlanContainer/ServicePlansPayment/ServicePlansInformation';

// Helpers / GraphQL
import { getServicePlans } from '../../../lib/graphql';
import { getPaymentMethods } from '../../../lib/graphql/servicePlans';
import messages from '../../../locale/jsonMessages';
import { dateFormat } from '../../../config';

import cs from '../../../components/commonStyle.css';
import s from './ServicePlanPayment.css';

const ServicePlanPayment = (props) => {
    const { id, account, userType } = props;
    const { formatMessage } = useIntl();

    const { data, loading } = useQuery(getServicePlans, {
        variables: { id: Number(id) },
        fetchPolicy: 'network-only',
        ssr: false,
    });

    const { data: getPaymentMethodData, loading: getPaymentMethodLoading } = useQuery(getPaymentMethods, {
        fetchPolicy: 'network-only',
        ssr: false,
    });

    if (loading || getPaymentMethodLoading) {
        return (
            <div>
                <Loader type="text" />
            </div>
        );
    }

    if (!loading && data?.getServicePlan?.status === 400) {
        return <NotFound />;
    }

    if (!loading && data?.getServicePlan?.status === 200) {
        const result = data?.getServicePlan?.result;
        const paymentMethods = getPaymentMethodData?.getPaymentMethods;

        const isStripeEnabled = paymentMethods && Array.isArray(paymentMethods)
            ? paymentMethods.find(method => method.paymentType === 2)?.isEnable || false
            : false;

        const today = new Date();
        const endDate = new Date();

        if (result?.duration) {
            endDate.setMonth(today.getMonth() + parseInt(result.duration));
        }

        const startDate = moment(today).format(dateFormat?.shortDateFormat);
        const lateDate = moment(endDate).format(dateFormat?.shortDateFormat);

        const initialValues = {
            paymentType: isStripeEnabled ? '2' : '1',
            price: result?.price,
            currency: result?.currency,
            userType: result?.userType,
            startDate,
            lateDate,
            serviceFee: result?.serviceFee,
            duration: result?.duration,
            servicePlanId: result?.id,
            servicePlanName: result?.planName,
            serviceDescription: result?.description,
            serviceAIFeature: result?.aiFeaturesStatus,
            userId: account?.userId
        };

        return (
            <div className={s.servicePlanPaymentContainer}>
                <div className={s.container}>
                    <h1 className={cx(cs.commonTitleText, cs.paddingBottom4)}>{formatMessage(messages.reviewAndPay)}</h1>
                    <div className={s.servicePlanPaymentRow}>
                        <div className={s.servicePlanPaymentCol1}>
                            <ElementsConsumer>
                                {({ stripe, elements }) => (
                                    <ServicePlansBookForm
                                        data={paymentMethods}
                                        initialValues={initialValues}
                                        stripe={stripe}
                                        elements={elements}
                                        userType={userType}
                                    />
                                )}
                            </ElementsConsumer>
                        </div>
                        <div className={s.servicePlanPaymentCol2}>
                            <ServicePlansInformation
                                data={result}
                                startDate={startDate}
                                lateDate={lateDate}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default withStyles(cs, s)(ServicePlanPayment);
